<template>
	<div class="puppy-svg-icon" role="img" :aria-label="alt" :title="title || undefined" :style="iconStyle" v-html="themedContent" />
</template>

<script setup lang="ts">
	import { computed } from "vue";
	import { applySvgThemeColorMapping } from "@/utils";

	const props = withDefaults(
		defineProps<{
			/** SVG 原始标记文本（由 `@/assets/icon/xx.svg?raw` 导入）。 */
			content: string;
			/** 图标渲染尺寸，同时作用于宽高。 */
			size?: string;
			/** 无障碍替代文本。 */
			alt?: string;
			/** 悬停提示文本。 */
			title?: string;
		}>(),
		{
			content: "",
			size: "",
			alt: "",
			title: "",
		}
	);

	/**
	 * 应用主题色映射后的 SVG 标记。
	 *
	 * 设计说明：内容来自仓库内静态 SVG 资源，且统一经过工具函数替换三档主题蓝；
	 * 组件禁止接收不可信内容，避免 v-html 注入风险。
	 */
	const themedContent = computed(() => applySvgThemeColorMapping(props.content));

	/**
	 * 图标容器尺寸。
	 *
	 * 设计说明：仅当显式传入 size 时写行内宽高；
	 * 未传入时由调用方通过 class（如 floating-panel-header__icon）控制尺寸。
	 */
	const iconStyle = computed(() => (props.size ? { width: props.size, height: props.size } : {}));
</script>

<style>
	/**
 * 必须使用非 scoped 样式：
 * v-html 插入的 <svg> 不会携带组件 scope 属性，scoped 选择器无法命中。
 * 根类名带 puppy- 前缀，避免污染全局样式。
 */
	.puppy-svg-icon {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		flex: none;
		width: 80%;
		height: 80%;
	}

	.puppy-svg-icon svg {
		width: 100%;
		height: 100%;
		display: block;
	}
</style>
